export default {
  lobby:{
    pano:"./lobby.png",
    marks: [
      {
        id: "welcome",
        polylineRad: [
          [2.453, 0.358],
          [3.23, 0.452],
          [3.23, -0.03],
          [2.452, -0.022],
          [2.453, 0.358]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Bienvenido",
          position: "right bottom"
        },
        info: {
          template: "welcome"
        }
      },
      {
        id: "tenochtitlan",
        polylineRad: [
          [1.347, 0.069],
          [1.491, 0.070],
          [1.492, -0.019],
          [1.346, -0.018],
          [1.347, 0.069]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Video: Caída de Tenochtitlán",
          position: "right bottom"
        },
        info: {
          template: "videoTenochtitlan"
        }
      },
      {
        id: "guadalupe",
        polylineRad: [
          [1.85, 0.070],
          [1.97, 0.069],
          [1.971, -0.014],
          [1.85, -0.015],
          [1.85, 0.070]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Video: Acontecimiento Guadalupano",
          position: "right bottom"
        },
        info: {
          template: "videoGuadalupe"
        }
      },
      {
        id: "independencia",
        polylineRad: [
          [2.244, 0.054],
          [2.32, 0.052],
          [2.319, -0.011],
          [2.244, -0.014],
          [2.244, 0.054]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Video: Consumación de la Independencia",
          position: "right bottom"
        },
        info: {
          template: "videoIndependencia"
        }
      },
      {
        id: "credits",
        polylineRad: [
          [3.36, 0.455],
          [3.96, 0.334],
          [3.96, -0.025],
          [3.36, -0.025],
          [3.36, 0.455]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Créditos",
          position: "right bottom"
        },
        info: {
          template: "credits",
          images: []
        }
      },
      {
        id: "timeline",
        polylineRad: [
          [4.194, 0.265],
          [5.097, 0.285],
          [5.097, -0.022],
          [4.194, -0.022],
          [4.194, 0.265]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Línea de tiempo",
          position: "right bottom"
        },
        info: {
          template: "timeline",
          images: [
            "galerias/lobby/timeline.jpg"
          ]
        }
      },
      {
        id: "logos",
        polylineRad: [
          [5.35, 0.346],
          [5.98, 0.521],
          [5.98, -0.039],
          [5.35, -0.026],
          [5.35, 0.346]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Listado de instituciones",
          position: "right bottom"
        },
        info: {
          template: "instituciones",
          images: []
        }
      },
      {
        id: "exit:sala1_1:0", // cmd, arg, marker id
        polylineRad: [
          [1.112, 0.176],
          [1.31, 0.185],
          [1.31, -0.145],
          [1.112, -0.135],
          [1.112, 0.176]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Sala 1: Caída de Tenochtitlán",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala2_1:0", // cmd, arg, marker id
        polylineRad: [
          [1.53, 0.191],
          [1.78, 0.185],
          [1.78, -0.145],
          [1.53, -0.144],
          [1.53, 0.191]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Sala 2: Acontecimiento Guadalupano",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala3_1:0", // cmd, arg, marker id
        polylineRad: [
          [2.008, 0.174],
          [2.164, 0.158],
          [2.164, -0.125],
          [2.008, -0.138],
          [2.008, 0.174]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Sala 3: Consumación de la Independencia",
          position: "center bottom"
        }
      },
      {
        id: "link:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [6.18, 0.23],
          [7.05, 0.165],
          [7.05, -0.14],
          [6.18, -0.19],
          [6.18, 0.23]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Sala de juego",
          position: "center bottom"
        }
      }
    ]
  },
  sala1_1:{
    pano:"./sala1_c1.png",
    marks: [
      {
        id: "markTimeline",
        polylineRad: [
          [2.15, 0.24],
          [2.74, 0.385],
          [2.74, -0.290],
          [2.15, -0.180],
          [2.15, 0.24]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Línea de tiempo: Caída de Tenochtitlán",
          position: "right bottom"
        },
        info: {
          template: "sala1timeline",
          images: [
            "galerias/tenochtitlan/timeline/L1_1_F.png"
          ]
        }
      },
      {
        id: "mark1",
        polylineRad: [
          [-0.645, 0.305],
          [0.369,  0.35],
          [0.369, -0.42],
          [-0.645, -0.37],
          [-0.645, 0.305]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La Gran Tenochtitlan. 1325-1521",
          position: "right bottom"
        },
        info: {
          template: "sala1m1",
          images: [
            "galerias/tenochtitlan/g1/g1.jpg",
            "galerias/tenochtitlan/g1/g1_a.jpg",
            "galerias/tenochtitlan/g1/g1_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG1.mp3",
            "galerias/tenochtitlan/audios/en/G1.mp3",
            "galerias/tenochtitlan/audios/nah/G1.mp3"
          ]
        }
      },  
      {
        id: "mark2",
        polylineRad: [
          [1.465, 0.175],
          [1.95, 0.165],
          [1.95, -0.190],
          [1.465, -0.2],
          [1.465, 0.175]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El desembarco de Cortés. 1519",
          position: "right bottom"
        },
        info: {
          template: "sala1m2",
          images: [
            "galerias/tenochtitlan/g2/g2.jpg",
            "galerias/tenochtitlan/g2/G2_a.jpg",
            "galerias/tenochtitlan/g2/G2_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG2.mp3",
            "galerias/tenochtitlan/audios/en/G2.mp3",
            "galerias/tenochtitlan/audios/nah/G2.mp3"
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [0.86, 0.135],
          [1.234, 0.167],
          [1.234, -0.192],
          [0.86, -0.155],
          [0.86, 0.135]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las alianzas militares. 1519",
          position: "right bottom"
        },
        info: {
          template: "sala1m3",
          images: [
            "galerias/tenochtitlan/g3/g3.jpg",
            "galerias/tenochtitlan/g3/G3_a.jpg",
            "galerias/tenochtitlan/g3/G3_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG3.mp3",
            "galerias/tenochtitlan/audios/en/G3.mp3",
            "galerias/tenochtitlan/audios/nah/G3.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [
          [-1.231, 0.165],
          [-0.86, 0.132],
          [-0.86, -0.155],
          [-1.231, -0.187],
          [-1.231, 0.165],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La llegada de los primeros franciscanos 1524",
          position: "right bottom"
        },
        info: {
          template: "sala1m8",
          images: [
            "galerias/tenochtitlan/g8/g8.jpg",
            "galerias/tenochtitlan/g8/G8_a.png",
            "galerias/tenochtitlan/g8/G8_b.png"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG8.mp3",
            "galerias/tenochtitlan/audios/en/G8.mp3",
            "galerias/tenochtitlan/audios/nah/G8.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [
          [-1.83, 0.168],
          [-1.555, 0.174],
          [-1.555, -0.20],
          [-1.83, -0.195],
          [-1.83, 0.168],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El gobierno virreinal: el Virrey y la Real Audiencia",
          position: "right bottom"
        },
        info: {
          template: "sala1m9",
          images: [
            "galerias/tenochtitlan/g9/g9.jpg",
            "galerias/tenochtitlan/g9/G9_a.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG9.mp3",
            "galerias/tenochtitlan/audios/en/G9.mp3",
            "galerias/tenochtitlan/audios/nah/G9.mp3"
          ]
        }
      },
      {
        id: "mark10",
        polylineRad: [
          [-2.44, 0.27],
          [-2.203, 0.21],
          [-2.203, -0.235],
          [-2.44, -0.3],
          [-2.44, 0.27],
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La memoria indígena: de la oralidad a la escritura",
          position: "right bottom"
        },
        info: {
          template: "sala1m10",
          images: [
            "galerias/tenochtitlan/g10/g10.jpg",
            "galerias/tenochtitlan/g10/G10_a.jpg",
            "galerias/tenochtitlan/g10/G10_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG10.mp3",
            "galerias/tenochtitlan/audios/en/G10.mp3",
            "galerias/tenochtitlan/audios/nah/G10.mp3"
          ]
        }
      },
      {
        id: "exit:sala1_2:0", // cmd, arg, marker id
        polylineRad: [
          [0.92, -0.4],
          [1.1, -0.3],
          [1.42, -0.33],
          [1.31, -0.49],
          [0.92, -0.4]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [2.94, -0.466],
          [2.94, 0.266],
          [3.51, 0.256],
          [3.51, -0.448],
          [2.94, -0.466]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      }
    ]
  },
  sala1_2:{
    pano:"./sala1_c2.png",
    marks: [
      {
        id: "mark2",
        polylineRad: [
          [2.41, 0.114],
          [2.59, 0.09],
          [2.59, -0.105],
          [2.41, -0.13],
          [2.41, 0.114]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El desembarco de Cortés. 1519",
          position: "right bottom"
        },
        info: {
          template: "sala1m2",
          images: [
            "galerias/tenochtitlan/g2/g2.jpg",
            "galerias/tenochtitlan/g2/G2_a.jpg",
            "galerias/tenochtitlan/g2/G2_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG2.mp3",
            "galerias/tenochtitlan/audios/en/G2.mp3",
            "galerias/tenochtitlan/audios/nah/G2.mp3"
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [1.92, 0.165],
          [2.29,  0.135],
          [2.29,  -0.152],
          [1.92,  -0.19],
          [1.92, 0.165]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las alianzas militares. 1519",
          position: "right bottom"
        },
        info: {
          template: "sala1m3",
          images: [
            "galerias/tenochtitlan/g3/g3.jpg",
            "galerias/tenochtitlan/g3/G3_a.jpg",
            "galerias/tenochtitlan/g3/G3_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG3.mp3",
            "galerias/tenochtitlan/audios/en/G3.mp3",
            "galerias/tenochtitlan/audios/nah/G3.mp3"
          ]
        }
      },
      {
        id: "mark4",
        polylineRad: [
          [1.331, 0.17],
          [1.61,  0.176],
          [1.61,  -0.199],
          [1.331,  -0.199],
          [1.331, 0.17]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La Matanza de Cholula. 1519",
          position: "right bottom"
        },
        info: {
          template: "sala1m4",
          images: [
            "galerias/tenochtitlan/g4/g4.jpg",
            "galerias/tenochtitlan/g4/G4_a.jpg",
            "galerias/tenochtitlan/g4/G4_4.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG4.mp3",
            "galerias/tenochtitlan/audios/en/G4.mp3",
            "galerias/tenochtitlan/audios/nah/G4.mp3"
          ]
        }
      },
      {
        id: "mark5",
        polylineRad: [
          [0.58, 0.235],
          [0.975,  0.155],
          [0.975, -0.18],
          [0.58, -0.265],
          [0.58, 0.235]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El encuentro entre Cortés y Moctezuma",
          position: "right bottom"
        },
        info: {
          template: "sala1m5",
          images: [
            "galerias/tenochtitlan/g5/g5.jpg",
            "galerias/tenochtitlan/g5/G5_a.jpg",
            "galerias/tenochtitlan/g5/G5_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG5.mp3",
            "galerias/tenochtitlan/audios/en/G5.mp3",
            "galerias/tenochtitlan/audios/nah/G5.mp3"
          ]
        }
      },
      {
        id: "mark5_m",
        polylineRad: [
          [5.78, 0.1],
          [5.78, -0.5],
          [0.5, -0.5],
          [0.5, 0.1],
          [5.78, 0.1]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Maqueta del templo mayor de Tenochtitlán",
          position: "right bottom"
        },
        info: {
          template: "sala1m5m",
          images: [
            "galerias/tenochtitlan/g5m/MAQUETA_1_A.jpg",
            "galerias/tenochtitlan/g5m/MAQUETA_1_B.jpg",
            "galerias/tenochtitlan/g5m/MAQUETA_1_C.jpg",
            "galerias/tenochtitlan/g5m/MAQUETA_1_D.jpg"
          ]
        }
      },
      {
        id: "mark6",
        polylineRad: [
          [-0.98, 0.156],
          [-0.59, 0.235],
          [-0.59, -0.265],
          [-0.98, -0.182],
          [-0.98, 0.156]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La caída de Tenochtitlán. 1521",
          position: "right bottom"
        },
        info: {
          template: "sala1m6",
          images: [
            "galerias/tenochtitlan/g6/g6.jpg",
            "galerias/tenochtitlan/g6/G6_a.png",
            "galerias/tenochtitlan/g6/G6_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG6.mp3",
            "galerias/tenochtitlan/audios/en/G6.mp3",
            "galerias/tenochtitlan/audios/nah/G6.mp3"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [
          [-1.595, 0.175],
          [-1.317, 0.17],
          [-1.317, -0.195],
          [-1.595, -0.2],
          [-1.595, 0.175]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La Conquista indígena. 1521",
          position: "right bottom"
        },
        info: {
          template: "sala1m7",
          images: [
            "galerias/tenochtitlan/g7/g7.jpg",
            "galerias/tenochtitlan/g7/G7_a.jpg",
            "galerias/tenochtitlan/g7/G7_b.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG7.mp3",
            "galerias/tenochtitlan/audios/en/G7.mp3",
            "galerias/tenochtitlan/audios/nah/G7.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [
          [-2.285, 0.135],
          [-1.92, 0.169],
          [-1.92, -0.190],
          [-2.285, -0.155],
          [-2.285, 0.135]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La llegada de los primeros Franciscanos 1524",
          position: "right bottom"
        },
        info: {
          template: "sala1m8",
          images: [
            "galerias/tenochtitlan/g8/g8.jpg",
            "galerias/tenochtitlan/g8/G8_a.png",
            "galerias/tenochtitlan/g8/G8_b.png"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG8.mp3",
            "galerias/tenochtitlan/audios/en/G8.mp3",
            "galerias/tenochtitlan/audios/nah/G8.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [
          [-2.552, 0.098],
          [-2.449, 0.11],
          [-2.449, -0.128],
          [-2.552, -0.113],
          [-2.552, 0.098]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El gobierno virreinal: el Virrey y la Real Audiencia",
          position: "right bottom"
        },
        info: {
          template: "sala1m9",
          images: [
            "galerias/tenochtitlan/g9/g9.jpg",
            "galerias/tenochtitlan/g9/G9_a.jpg"
          ],
          audios: [
            "galerias/tenochtitlan/audios/es/TG9.mp3",
            "galerias/tenochtitlan/audios/en/G9.mp3",
            "galerias/tenochtitlan/audios/nah/G9.mp3"
          ]
        }
      },
      {
        id: "exit:sala1_1:0", // cmd, arg, marker id
        polylineRad: [
          [-2.162, -0.265],
          [-1.84, -0.305],
          [-2, -0.47],
          [-2.37, -0.36],
          [-2.162, -0.265]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala2_1:{
    pano:"./sala2_c1.png",
    marks: [
      {
        id: "markTimeline",
        polylineRad: [
          [1.32, 0.208],
          [1.97, 0.2],
          [1.97, -0.125],
          [1.32, -0.13],
          [1.32, 0.208]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Línea de tiempo: Acontecimiento Guadalupano",
          position: "right bottom"
        },
        info: {
          template: "sala2timeline",
          images: [
            "galerias/guadalupe/timeline/timeline.jpg"
          ]
        }
      },
      {
        id: "mark1",
        polylineRad: [
          [0.026, 0.415],
          [0.673, 0.328],
          [0.668, -0.372],
          [0.026, -0.46],
          [0.026, 0.415]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Aparición de la Virgen de Guadalupe. 1531",
          position: "right bottom"
        },
        info: {
          template: "sala2m1",
          images: [
            "galerias/guadalupe/g1/g1.jpg",
            "galerias/guadalupe/g1/G1_a.jpg",
          ],
          audios: [
            "galerias/guadalupe/audios/es/G1.mp3",
            "galerias/guadalupe/audios/en/G1.mp3",
            "galerias/guadalupe/audios/nah/G1.mp3"
          ]
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [0.96, 0.13],
          [1.162, 0.146],
          [1.162, -0.172],
          [0.96, -0.154],
          [0.96, 0.13]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las Apariciones de la Virgen a Juan Diego. 1531",
          position: "right bottom"
        },
        info: {
          template: "sala2m2",
          images: [
            "galerias/guadalupe/g2/g2.jpg",
            "galerias/guadalupe/g2/G2_a.jpg",
          ],
          audios: [
            "galerias/guadalupe/audios/es/G2.mp3",
            "galerias/guadalupe/audios/en/G2.mp3",
            "galerias/guadalupe/audios/nah/G2.mp3"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [
          [-1.185, 0.13],
          [-1.025, 0.12],
          [-1.025, -0.14],
          [-1.185, -0.152],
          [-1.185, 0.13]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "En 1754 Benedicto XIV proclama a la Virgen de Guadalupe como Patrona de la Nueva España",
          position: "right bottom"
        },
        info: {
          template: "sala2m7",
          images: [
            "galerias/guadalupe/g8/G8.jpg",
            "galerias/guadalupe/g8/G8_A.jpg",
            "galerias/guadalupe/g8/G8_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/VG8.mp3",
            "galerias/guadalupe/audios/en/G8.mp3",
            "galerias/guadalupe/audios/nah/G8.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [
          [-2.66, 0.32],
          [-2.325, 0.25],
          [-2.325, -0.28],
          [-2.66, -0.355],
          [-2.66, 0.32]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Primer Estandarte de la Insurgencia, 1810.",
          position: "right bottom"
        },
        info: {
          template: "sala2m8",
          images: [
            "galerias/guadalupe/g9/G9.jpg",
            "galerias/guadalupe/g9/G9_A.jpg",
          ],
          audios: [
            "galerias/guadalupe/audios/es/G8.mp3",
            "galerias/guadalupe/audios/en/G9.mp3",
            "galerias/guadalupe/audios/nah/G9.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [
          [2.246, 0.223],
          [2.77, 0.326],
          [2.767, -0.253],
          [2.246, -0.17],
          [2.246, 0.223]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Festejos del centenario del inicio de la independencia, 1910",
          position: "right bottom"
        },
        info: {
          template: "sala2m9",
          images: [
            "galerias/guadalupe/g10/G10.jpg",
            "galerias/guadalupe/g10/G10_A.jpg",
            "galerias/guadalupe/g10/G10_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/G9.mp3",
            "galerias/guadalupe/audios/en/G10.mp3",
            "galerias/guadalupe/audios/nah/G10.mp3"
          ]
        }
      },
      {
        id: "mark10",
        polylineRad: [
          [-0.92, 0.285],
          [-0.585, 0.36],
          [-0.585, -0.4],
          [-0.92, -0.28],
          [-0.92, 0.285]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La canonización de Juan Diego",
          position: "right bottom"
        },
        info: {
          template: "sala2m10",
          images: [
            "galerias/guadalupe/g11/G11.jpg",
            "galerias/guadalupe/g11/G11_A.jpg",
            "galerias/guadalupe/g11/G11_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/G11.mp3",
            "galerias/guadalupe/audios/en/G11.mp3",
            "galerias/guadalupe/audios/nah/G11.mp3"
          ]
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [4.37, 0.132],
          [4.65, 0.14],
          [4.65, -0.26],
          [4.37, -0.245],
          [4.37, 0.132]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala2_2:0", // cmd, arg, marker id
        polylineRad: [
          [1.22, -0.247],
          [1.65, -0.26],
          [1.7, -0.45],
          [1.06, -0.4],
          [1.22, -0.247]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala2_2:{
    pano:"./sala2_c2.png",
    marks: [
      {
        id: "mark2",
        polylineRad: [
          [1.735, 0.155],
          [1.975, 0.145],
          [1.975, -0.172],
          [1.735, -0.185],
          [1.735, 0.155]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las Apariciones de la Virgen a Juan Diego. 1531",
          position: "right bottom"
        },
        info: {
          template: "sala2m2",
          images: [
            "galerias/guadalupe/g2/g2.jpg",
            "galerias/guadalupe/g2/G2_a.jpg",
          ],
          audios: [
            "galerias/guadalupe/audios/es/G2.mp3",
            "galerias/guadalupe/audios/en/G2.mp3",
            "galerias/guadalupe/audios/nah/G2.mp3"
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [1.2, 0.13],
          [1.382, 0.136],
          [1.382, -0.158],
          [1.2, -0.15],
          [1.2, 0.13]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Luis Lasso de la Vega publica el Huey Tlamahuicoltica en 1649",
          position: "right bottom"
        },
        info: {
          template: "sala2m3",
          images: [
            "galerias/guadalupe/g4/G4.jpg",
            "galerias/guadalupe/g4/G4_A.jpg",
            "galerias/guadalupe/g4/G4_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/G3-1.mp3",
            "galerias/guadalupe/audios/en/G4.mp3",
            "galerias/guadalupe/audios/nah/G4.mp3"
          ]
        }
      },
      {
        id: "mark3_1",
        polylineRad: [
          [1.39, 0.03],
          [1.53, 0.03],
          [1.53, -0.348],
          [1.39, -0.34],
          [1.39, 0.03]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Nican Mopohua (copia de un original de 1556)",
          position: "right bottom"
        },
        info: {
          template: "sala2m3s1",
          images: [
            "galerias/guadalupe/g3/G3.jpg",
            "galerias/guadalupe/g3/G3_A.jpg",
            "galerias/guadalupe/g3/G3_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/G3.mp3",
            "galerias/guadalupe/audios/en/G3.mp3",
            "galerias/guadalupe/audios/nah/G3.mp3"
          ]
        }
      },
      {
        id: "mark4",
        polylineRad: [
          [0.626, 0.185],
          [0.888, 0.145],
          [0.888, -0.165],
          [0.626, -0.21],
          [0.626, 0.185]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "En 1667 se instituye el 12 de diciembre como Jubileo plenísimo a la Virgen de Guadalupe",
          position: "right bottom"
        },
        info: {
          template: "sala2m4",
          images: [
            "galerias/guadalupe/g5/G5.jpg",
            "galerias/guadalupe/g5/G5_A.jpg",
            "galerias/guadalupe/g5/G5_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/G4.mp3",
            "galerias/guadalupe/audios/en/G5.mp3",
            "galerias/guadalupe/audios/nah/G5.mp3"
          ]
        }
      },
      {
        id: "mark4_1",
        polylineRad: [
          [5.933, 0.09],
          [0.338, 0.093],
          [0.346, -0.334],
          [5.932, -0.336],
          [5.933, 0.09]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Maqueta de la actual basílica de Guadalupe",
          position: "right bottom"
        },
        info: {
          template: "sala2m4s1",
          images: [
            "galerias/guadalupe/g4m/MAQUETA2_B.jpg",
            "galerias/guadalupe/g4m/MAQUETA2_A.jpg",
            "galerias/guadalupe/g4m/MAQUETA2_C.jpg",
            "galerias/guadalupe/g4m/MAQUETA2_D.jpg"
          ],
          audios: [
          ]
        }
      },
      {
        id: "mark5",
        polylineRad: [
          [-0.953, 0.133],
          [-0.62, 0.185],
          [-0.62, -0.215],
          [-0.953, -0.15],
          [-0.953, 0.135]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "En 1709 se consagra el nuevo santuario en el Cerro del Tepeyac",
          position: "right bottom"
        },
        info: {
          template: "sala2m5",
          images: [
            "galerias/guadalupe/g6/G6.jpg",
            "galerias/guadalupe/g6/G6_A.jpg",
          ],
          audios: [
            "galerias/guadalupe/audios/es/G5.mp3",
            "galerias/guadalupe/audios/en/G6.mp3",
            "galerias/guadalupe/audios/nah/G6.mp3"
          ]
        }
      },
      {
        id: "mark5_1",
        polylineRad: [
          [2.62, 0.12],
          [2.97, 0.135],
          [2.97, -0.35],
          [2.62, -0.318],
          [2.62, 0.12]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Virgen de Guadalupe, Patricio Morlete Ruiz",
          position: "right bottom"
        },
        info: {
          template: "sala2m5s1",
          images: [
            "galerias/guadalupe/g6_1/G6_1.jpg"
          ]
        }
      },
      {
        id: "mark5_2",
        polylineRad: [
          [-1.63, 0.1],
          [-1.5, 0.1],
          [-1.5, -0.31],
          [-1.63, -0.31],
          [-1.63, 0.1]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Virgen de Guadalupe, Anónimo",
          position: "right bottom"
        },
        info: {
          template: "sala2m5s2",
          images: [
            "galerias/guadalupe/g6_2/G6_2_A.jpg",
            "galerias/guadalupe/g6_2/G6_2_B.jpg",
            "galerias/guadalupe/g6_2/G6_2_C.jpg"
          ]
        }
      },
      {
        id: "mark6",
        polylineRad: [
          [-1.405, 0.138],
          [-1.19, 0.129],
          [-1.19, -0.148],
          [-1.405, -0.158],
          [-1.405, 0.138]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Inspección del lienzo de la Virgen de Guadalupe por parte de pintores virreinales. 1751",
          position: "right bottom"
        },
        info: {
          template: "sala2m6",
          images: [
            "galerias/guadalupe/g7/G7.jpg",
            "galerias/guadalupe/g7/G7_A.jpg",
            "galerias/guadalupe/g7/G7_B.jpg",
          ],
          audios: [
            "galerias/guadalupe/audios/es/G6.mp3",
            "galerias/guadalupe/audios/en/G7.mp3",
            "galerias/guadalupe/audios/nah/G7.mp3"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [
          [-1.998, 0.128],
          [-1.82, 0.135],
          [-1.82, -0.155],
          [-1.998, -0.145],
          [-1.998, 0.128]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "En 1754 Benedicto XIV proclama a la Virgen de Guadalupe como Patrona de la Nueva España",
          position: "right bottom"
        },
        info: {
          template: "sala2m7",
          images: [
            "galerias/guadalupe/g8/G8.jpg",
            "galerias/guadalupe/g8/G8_A.jpg",
            "galerias/guadalupe/g8/G8_B.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/VG8.mp3",
            "galerias/guadalupe/audios/en/G8.mp3",
            "galerias/guadalupe/audios/nah/G8.mp3"
          ]
        }
      },
      {
        id: "mark7_1",
        polylineRad: [
          [-2.58, 0.37],
          [-2.235, 0.28],
          [-2.235, -0.28],
          [-2.58, -0.38],
          [-2.58, 0.37]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Patronato de la Virgen de Guadalupe",
          position: "right bottom"
        },
        info: {
          template: "sala2m7s1",
          images: [
            "galerias/guadalupe/g8_1/G8_1.jpg"
          ],
          audios: [
            "galerias/guadalupe/audios/es/G8-1.mp3",
            "galerias/guadalupe/audios/en/G8-1.mp3",
            "galerias/guadalupe/audios/nah/G8-1.mp3"
          ]
        }
      },
      {
        id: "exit:sala2_1:0", // cmd, arg, marker id
        polylineRad: [
          [-2.04, -0.28],
          [-1.6, -0.31],
          [-1.62, -0.46],
          [-2.2, -0.38],
          [-2.04, -0.28]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala3_1:{
    pano:"./sala3_c1.png",
    marks: [
      {
        id: "markTimeline",
        polylineRad: [
          [-1.94, 0.20],
          [-1.34, 0.214],
          [-1.34, -0.15],
          [-1.94, -0.14],
          [-1.94, 0.20]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Línea de tiempo: Consumación de la Independencia",
          position: "right bottom"
        },
        info: {
          template: "sala3timeline",
          images: [
            "galerias/independencia/timeline/timeline.jpg"
          ]
        }
      },
      {
        id: "mark1",
        polylineRad: [
          [-0.87, 0.24],
          [-0.52, 0.315],
          [-0.52, -0.36],
          [-0.87, -0.275],
          [-0.87, 0.24]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El Virreinato a finales del siglo XVIII",
          position: "right bottom"
        },
        info: {
          title: "El Virreinato a finales del siglo XVIII",
          template: "sala3m1",
          images: [
            "galerias/independencia/g1/G1.jpg",
            "galerias/independencia/g1/G1_A.jpg",
            "galerias/independencia/g1/G1_B.png",
            "galerias/independencia/g1/G1_C.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG1.mp3",
            "galerias/independencia/audios/en/G1.mp3",
            "galerias/independencia/audios/nah/G1.mp3"
          ]
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [-2.21, 0.225],
          [-2.042, 0.171],
          [-2.042, -0.194],
          [-2.21, -0.256],
          [-2.21, 0.225]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las Reformas Borbónicas",
          position: "right bottom"
        },
        info: {
          title: "Las Reformas Borbónicas",
          template: "sala3m2",
          images: [
            "galerias/independencia/g2/G2.jpg",
            "galerias/independencia/g2/G2_A.jpg",
            "galerias/independencia/g2/G2_B.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG2.mp3",
            "galerias/independencia/audios/en/G2.mp3",
            "galerias/independencia/audios/nah/G2.mp3"
          ]
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [-3.6, 0.335],
          [-2.6, 0.321],
          [-2.6, -0.36],
          [-3.6, -0.38],
          [-3.6, 0.335]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La insurgencia de 1810",
          position: "right bottom"
        },
        info: {
          title: "La insurgencia de 1810",
          template: "sala3m3",
          images: [
            "galerias/independencia/g3/G3.jpg",
            "galerias/independencia/g3/G3_A.jpg",
            "galerias/independencia/g3/G3_B.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG3.mp3",
            "galerias/independencia/audios/en/G3.mp3",
            "galerias/independencia/audios/nah/G3.mp3"
          ]
        }
      },
      {
        id: "mark4",
        polylineRad: [
          [1.975, 0.15],
          [2.25, 0.235],
          [2.25, -0.27],
          [1.975, -0.173],
          [1.975, 0.15]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La participación de las mujeres en la insurgencia",
          position: "right bottom"
        },
        info: {
          title: "La participación de las mujeres en la insurgencia",
          template: "sala3m4",
          images: [
            "galerias/independencia/g4/G4.jpg",
            "galerias/independencia/g4/G4_A.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG4.mp3",
            "galerias/independencia/audios/en/G4.mp3",
            "galerias/independencia/audios/nah/G4.mp3"
          ]
        }
      },
      {
        id: "mark5",
        polylineRad: [
          [0.6, 0.298],
          [0.909, 0.225],
          [0.909, -0.255],
          [0.6, -0.338],
          [0.6, 0.298]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Las Cortes de Cádiz y la Constitución de 1812",
          position: "right bottom"
        },
        info: {
          title: "Las Cortes de Cádiz y la Constitución de 1812",
          template: "sala3m5",
          images: [
            "galerias/independencia/g5/G5.jpg",
            "galerias/independencia/g5/G5_A.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG5.mp3",
            "galerias/independencia/audios/en/G5.mp3",
            "galerias/independencia/audios/nah/G5.mp3"
          ]
        }
      },
      {
        id: "mark6",
        polylineRad: [
          [1.305, 0.135],
          [1.7, 0.138],
          [1.7, -0.158],
          [1.305, -0.155],
          [1.305, 0.135]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El Plan de Iguala y el Ejército Trigarante",
          position: "right bottom"
        },
        info: {
          title: "El Plan de Iguala y el Ejército Trigarante",
          template: "sala3m6",
          images: [
            "galerias/independencia/g6/G6.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG6.mp3",
            "galerias/independencia/audios/en/G6.mp3",
            "galerias/independencia/audios/nah/G6.mp3"
          ]
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [4.95, 0.136],
          [5.2, 0.126],
          [5.2, -0.23],
          [4.95, -0.246],
          [4.95, 0.136]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala3_2:0", // cmd, arg, marker id
        polylineRad: [
          [1.15, -0.24],
          [1.5, -0.258],
          [1.47, -0.365],
          [1.05, -0.318],
          [1.15, -0.24]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  },
  sala3_2:{
    pano:"./sala3_c2.png",
    marks: [
      {
        id: "mark6_1",
        polylineRad: [
          [1.527, 0.195],
          [1.715, 0.195],
          [1.715, -0.32],
          [1.527, -0.32],
          [1.527, 0.195]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Medallón conmemorativo",
          position: "right bottom"
        },
        info: {
          template: "sala3m7",
          images: [
            "galerias/independencia/g6_1/G6_1.png"
          ]
        }
      },
      {
        id: "mark7",
        polylineRad: [
          [0.83, 0.254],
          [1.041, 0.19],
          [1.041, -0.216],
          [0.83, -0.287],
          [0.83, 0.255]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El alto clero poblano y el proceso de Independencia",
          position: "right bottom"
        },
        info: {
          title: "El alto clero poblano y el proceso de Independencia",
          template: "sala3m8",
          images: [
            "galerias/independencia/g7/G7.jpg",
          ],
          audios: [
            "galerias/independencia/audios/es/G7.mp3",
            "galerias/independencia/audios/en/G7.mp3",
            "galerias/independencia/audios/nah/G7.mp3"
          ]
        }
      },
      {
        id: "mark7_1",
        polylineRad: [
          [-0.17, 0.335],
          [0.42, 0.31],
          [0.42, -0.36],
          [-0.175, -0.39],
          [-0.17, 0.335]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Puebla: la primera ciudad jurada independiente",
          position: "right bottom"
        },
        info: {
          title: "Puebla: la primera ciudad jurada independiente",
          template: "sala3m9",
          images: [
            "galerias/independencia/g7_1/G7_1.png",
            "galerias/independencia/g7_1/G71_A.png"
          ],
          audios: [
            "galerias/independencia/audios/es/IG7-1.mp3",
            "galerias/independencia/audios/en/G7-1.mp3",
            "galerias/independencia/audios/nah/G7-1.mp3"
          ]
        }
      },
      {
        id: "mark8",
        polylineRad: [
          [-1.1, 0.175],
          [-0.708, 0.288],
          [-0.708, -0.326],
          [-1.1, -0.2],
          [-1.1, 0.175]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Los Tratados de Córdoba",
          position: "right bottom"
        },
        info: {
          title: "Los Tratados de Córdoba",
          template: "sala3m10",
          images: [
            "galerias/independencia/g8/G8.jpg",
            "galerias/independencia/g8/G8_A.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG8.mp3",
            "galerias/independencia/audios/en/G8.mp3",
            "galerias/independencia/audios/nah/G8.mp3"
          ]
        }
      },
      {
        id: "mark9",
        polylineRad: [
          [2.102, 0.188],
          [2.555, 0.304],
          [2.555, -0.35],
          [2.102, -0.22],
          [2.102, 0.185]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "La entrada triunfal de Iturbide a Ciudad de México y la firma del Acta de Independencia.",
          position: "right bottom"
        },
        info: {
          title: "La entrada triunfal de Iturbide a Ciudad de México y la firma del Acta de Independencia.",
          template: "sala3m11",
          images: [
            "galerias/independencia/g9/G9.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG9.mp3",
            "galerias/independencia/audios/en/G9.mp3",
            "galerias/independencia/audios/nah/G9.mp3"
          ]
        }
      },
      {
        id: "mark10",
        polylineRad: [
          [-2.537, 0.344],
          [-2.195, 0.25],
          [-2.195, -0.28],
          [-2.537, -0.386],
          [-2.537, 0.344]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "El gobierno provisional y el primer Imperio",
          position: "right bottom"
        },
        info: {
          title: "El gobierno provisional y el primer Imperio",
          template: "sala3m12",
          images: [
            "galerias/independencia/g10/G10.jpg"
          ],
          audios: [
            "galerias/independencia/audios/es/IG10.mp3",
            "galerias/independencia/audios/en/G10.mp3",
            "galerias/independencia/audios/nah/G10.mp3"
          ]
        }
      },
      {
        id: "mark11",
        polylineRad: [
          [-1.648, 0.143],
          [-1.402, 0.143],
          [-1.402, -0.174],
          [-1.648, -0.177],
          [-1.648, 0.143]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Agustín de Iturbide, el primer emperador de México.",
          position: "right bottom"
        },
        info: {
          title: "Agustín de Iturbide, el primer emperador de México.",
          template: "sala3m13",
          images: [
            "galerias/independencia/g11/G11.jpg",
            "galerias/independencia/g11/G11_A.jpg",
            "galerias/independencia/g11/G11_B.png"
          ],
          audios: [
            "galerias/independencia/audios/es/IG11.mp3",
            "galerias/independencia/audios/en/G11.mp3",
            "galerias/independencia/audios/nah/G11.mp3"
          ]
        }
      },
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [4.215, 0.128],
          [4.38, 0.135],
          [4.38, -0.245],
          [4.215, -0.225],
          [4.215, 0.128]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Salida",
          position: "center bottom"
        }
      },
      {
        id: "exit:sala3_1:0", // cmd, arg, marker id
        polylineRad: [
          [-1.9, -0.256],
          [-1.58, -0.268],
          [-1.59, -0.4],
          [-2.02, -0.36],
          [-1.9, -0.256]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Continúa parte 2",
          position: "center bottom"
        }
      }
    ]
  }
};
